import React from 'react';
import styled from 'styled-components';
import { CircleSpinner } from 'react-spinners-kit';
import axios from 'axios';
import buttonIconUrl from '../../images/newsletter-signup.svg';

const ContactBoxContainer = styled.div`
  padding: 0 25px;
`;

const ContactBoxInner = styled.div`
  box-sizing: border-box;
  max-width: 990px;
  margin: 0 auto;
  background: #fafafa;
  text-align: center;
  font-size: 20px;
  line-height: 24px;
  padding: 60px 25px;
  border-radius: 12px;
  /* TODO find real color */
  border: 1px solid #f4f4f4;
  letter-spacing: 0.3px;
`;
const ContactBoxHeadline = styled.div`
  font-size: 20px;
  font-weight: 600;
`;
const ContactBoxDescription = styled.div`
  color: #999999;
  font-weight: 300;
`;

const InputForm = styled.form`
  max-width: 350px;
  margin: 24px auto 0;
  display: flex;
  justify-content: center;
`;

const Input = styled.input`
  box-sizing: border-box;
  padding: 0 20px;
  border: 1px solid rgba(156, 156, 156, 0.4);
  box-shadow: none;
  border-right: none;
  height: 50px;
  flex: 1;
  outline: none;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  font-size: 16px;
  letter-spacing: 0.3px;
`;

const Button = styled.button`
  outline: none;
  background: white;
  width: 52px;
  border-color: rgba(156, 156, 156, 0.4);
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;

  &:hover {
    cursor: pointer;
  }

  img {
    width: 24px;
    padding-top: 5px;
    margin: 0;
  }
`;

const SpinnerWrapper = styled.div`
  padding-left: 5.40625px;
`;

function ContactBox({ input }) {
  const [buttonDisabled, setButtonDisabled] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const emailInput = React.useRef(null);

  const onSubmit = () => {
    setButtonDisabled(true);
    setSubmitting(true);

    axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${process.env.HUBSPOT_ID}/${process.env.HUBSPOT_LEAD_FORM_ID}`, {
      fields: [
        {
          name: "email",
          value: emailInput.current.value
        },
      ],
      context: {
        pageUri: location.href,
        pageName: location.pathname,
      }
    }).then((res) => {
      setSubmitting(false);
      setButtonDisabled(false);
      alert('Thanks for signing up!');
      emailInput.current.value = '';
    }).catch((err) => {
      alert('There was an issue with submitting your email. Please try again.');
      setSubmitting(false);
      setButtonDisabled(false);
    });
  };

  return (
    <ContactBoxContainer>
      <ContactBoxInner>
        <ContactBoxHeadline>{input.primary.headline.text}</ContactBoxHeadline>
        <ContactBoxDescription>{input.primary.description.text}</ContactBoxDescription>
        <InputForm>
          <Input
            ref={emailInput}
            type="email"
            placeholder={input.primary.input_placeholder.text}
          />
          <Button
            type="submit"
            onClick={onSubmit}
            disabled={buttonDisabled}
          >
            {!submitting && <img src={buttonIconUrl} />}
            {submitting && <SpinnerWrapper><CircleSpinner size={16} color="#000" /></SpinnerWrapper>}
          </Button>
        </InputForm>
      </ContactBoxInner>
    </ContactBoxContainer>
  );
}

export { ContactBox };
